<template>
  <i
    v-tooltip.top="text"
    class="pi pi-info-circle cursor-help text-bluegray-400 ml-2"
    style="font-size: 0.75rem"
  />
</template>

<script>
export default {
  name: "InfoIcon",
  props: {
    text: { type: String, required: true },
  },
};
</script>
